/* Testimonial Videos — Video cards with play/pause/mute */
(function() {
  'use strict';

  var container = document.querySelector('[data-testimonial-videos]');
  if (!container) return;

  var cards = container.querySelectorAll('.testimonial-video-card');

  cards.forEach(function(card) {
    var video = card.querySelector('video');
    var playBtn = card.querySelector('[data-video-play-pause]');
    var muteBtn = card.querySelector('[data-video-mute]');

    if (!video) return;

    /* Lazy load via IntersectionObserver */
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          video.preload = 'auto';
          video.play().catch(function() {});
          observer.disconnect();
        }
      });
    }, { threshold: 0.3 });
    observer.observe(card);

    if (playBtn) {
      playBtn.addEventListener('click', function() {
        if (video.paused) video.play().catch(function() {});
        else video.pause();
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function() {
        video.muted = !video.muted;
      });
    }
  });
})();
